import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const STATUS_OPTIONS = ["pending", "confirmed", "cancelled", "completed"];

export default function AdminBookings() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/admin/bookings").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/admin/bookings/${id}`, { status });
      toast.success("Status updated");
      load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <h2 className="font-serif-display text-2xl mb-6">Bookings ({items.length})</h2>
      {items.length === 0 ? (
        <div className="text-center py-16 text-[hsl(100_3%_30%)]">No bookings yet.</div>
      ) : (
        <div className="border border-[hsl(165_37%_17%/0.1)] rounded-md bg-white divide-y divide-[hsl(165_37%_17%/0.08)]">
          {items.map((b) => (
            <div key={b.id} className="p-4 grid grid-cols-1 md:grid-cols-6 gap-3 items-center" data-testid={`admin-booking-${b.id}`}>
              <div className="md:col-span-2 min-w-0">
                <p className="font-medium truncate">{b.property?.title}</p>
                <p className="text-xs text-[hsl(100_3%_30%)]">{b.guest_name} · {b.guest_email}</p>
                <p className="text-xs text-[hsl(100_3%_30%)]">📞 {b.guest_phone}</p>
              </div>
              <div className="text-sm">
                <p>{b.check_in} → {b.check_out}</p>
                <p className="text-xs text-[hsl(100_3%_30%)]">{b.nights} nights · {b.guests} guests</p>
              </div>
              <div className="text-sm">
                <p>₹{b.total_amount.toLocaleString("en-IN")}</p>
                <Badge className="text-[10px] mt-1">{b.payment_status}</Badge>
              </div>
              <div>
                <Select value={b.status} onValueChange={(v) => updateStatus(b.id, v)}>
                  <SelectTrigger className="h-9" data-testid={`booking-status-select-${b.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {STATUS_OPTIONS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div className="text-xs text-[hsl(100_3%_30%)] text-right">
                #{b.id.slice(0, 6).toUpperCase()}<br/>
                {new Date(b.created_at).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
